import { take, fork, all } from "redux-saga/effects";

// Fetches data for a User : user data + starred repos
function* watchLoadUserPage() {
	while (true) {
		const { aaa } = yield take("stats/SELECT_MAIN_FILTER");
	}
}

export default function* root() {
	yield all([fork(watchLoadUserPage)]);
}



// WEBPACK FOOTER //
// src/redux/sagas/saga.js